<template>
  <header id='header'>
    <div class='inner'>
      <div class='col col1'>
        <a class='btnNavi prev'>
          <span @click.stop.prevent='backBtn' class='ico'>이전</span>
        </a>
      </div>
      <div class='col col2'>
      <!-- 마이페이지, 주문내역 -->
        <h1>{{$t(`${fullVUi?'MyPage.myPage':'MyPage.orderHistory'}`)}}</h1>
      </div>
      <div class='col col3'>
        <a class='btnNavi langNavi' v-if="this.globalType == 1 && this.isGlobalButtonEnabled()">
          <span
            @click="toggleLangBox()"
            class="ico lang"
            :class="{ ko: isKo, en: isEn, cn: isCn}"></span>
          <div class="langBox" style="display: none">
            <span class="ico lang ko" @click="setKorean()"></span>
            <span class="ico lang en" @click="setEnglish()"></span>
            <span class="ico lang ch" @click="setChinese()"></span>
          </div>
        </a>
        <a v-if='fullVUi' class='btnNavi sch'>
          <span @click.stop.prevent='moveToSearchPage' class='ico'>검색</span>
        </a>
      </div>
    </div>
  </header>
</template>
<script lang="js">
import { THROW_SEARCH } from '@/router'
import { MYPAGE_HEADER } from '@/utils/EndPoint'
import Vue from 'vue'
import $ from 'jquery'
export default Vue.extend({
  name: MYPAGE_HEADER,
  data () {
    return {
      fullVUi: ''
    }
  },
  computed: {
    modnPayUrl () { return this.$store.getters.modnPayUrl },
    isKo () {
      return this.$i18n.locale === 'ko'
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    isCn () {
      return this.$i18n.locale === 'cn'
    },
    globalType () {
      return this.$store.state.MainIndex.globalType
    }
  },
  mounted () {
    window.backBtn = () => {
      this.backBtn()
    }
    this.fullVUi = sessionStorage.getItem('fullVUi')
  },
  methods: {
    backBtn () {
      if (this.$route.query.modnPayFlag) { // 모든페이에서 주문내역을 호출한 경우
        if (window.__wxjs_environment === 'miniprogram') { // 미니프로그램인 경우 history back
          const langType = this.$i18n.locale
          window.wx.miniProgram.redirectTo({ url: `/mini/store?langType=${langType}` }) // 미니프로그램 상점 리스트 페이지로 이동
        } else {
          this.requestReScan(this.modnPayUrl)
        }
      } else {
        // 이전 페이지로 이동
        history.back()
      }
    },
    moveToSearchPage () { THROW_SEARCH() },
    toggleLangBox () {
      $('#header .langNavi .langBox').fadeToggle(200)
    },
    setKorean () {
      this.$i18n.locale = 'ko'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      this.$emit('reloadMainPage')
      this.toggleLangBox()
    },
    setEnglish () {
      this.$i18n.locale = 'en'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      this.$emit('reloadMainPage')
      this.toggleLangBox()
    },
    setChinese () {
      this.$i18n.locale = 'cn'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = 'MODNPAY智慧点餐'
      this.$emit('reloadMainPage')
      this.toggleLangBox()
    }
  }
})
</script>
